import { useQuery } from "@apollo/client";

import { REFRESH_INTERVAL_MS } from "../constants";
import { consoleValetCapacityForecast } from "./queries";

export default function useValetCapacityForecast(installationId, month) {
  const { data, loading, error, refetch } = useQuery(
    consoleValetCapacityForecast,
    {
      variables: { installationId, month },
      skip: !installationId || !month,
      fetchPolicy: "cache-and-network",
      pollInterval: REFRESH_INTERVAL_MS,
    },
  );
  const forecast = data?.consoleValetCapacityForecast ?? null;

  return {
    forecast,
    loading: loading && !forecast,
    error,
    refetch,
  };
}
